import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["MenuListProps", "ButtonGroupProps", "children", "isLoading", "onClick", "label"];
import { ButtonGroup, MenuList, Popover } from '@material-ui/core';
import * as React from 'react';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { ColorDynamic, mergeRefs, useUID } from "../index.js";
import { Button } from "../button/Button.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function CaretDownIcon() {
  return /*#__PURE__*/_jsx("svg", {
    viewBox: "0 0 8 4",
    children: /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "M0.666687 0.666656L4.00002 3.99999L7.33335 0.666656H0.666687Z"
    })
  });
}
var CaretButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "DropdownButton__CaretButton",
  componentId: "SD__sc-8l84jm-0"
})(["width:auto;", ";"], _ref => {
  var {
    variant
  } = _ref;
  return variant === 'contained' && "border-left: 1px solid ".concat(ColorDynamic.Blue500);
});
export var DropdownButton = /*#__PURE__*/forwardRef((_ref2, ref) => {
  var _anchorRef$current2;
  var {
      MenuListProps,
      ButtonGroupProps,
      children,
      isLoading,
      onClick,
      label
    } = _ref2,
    buttonProps = _objectWithoutProperties(_ref2, _excluded);
  var uid = useUID();
  var [open, setOpen] = React.useState(false);
  var anchorRef = React.useRef(null);
  function handleClick(event) {
    setOpen(false);
    onClick === null || onClick === void 0 ? void 0 : onClick(event);
  }
  function handleToggle() {
    setOpen(prevOpen => !prevOpen);
  }
  function handleClose(event) {
    var _anchorRef$current;
    if ((_anchorRef$current = anchorRef.current) !== null && _anchorRef$current !== void 0 && _anchorRef$current.contains(event.currentTarget)) {
      return;
    }
    setOpen(false);
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(ButtonGroup, _objectSpread(_objectSpread({}, ButtonGroupProps), {}, {
      ref: mergeRefs(ButtonGroupProps === null || ButtonGroupProps === void 0 ? void 0 : ButtonGroupProps.ref, anchorRef),
      fullWidth: (ButtonGroupProps === null || ButtonGroupProps === void 0 ? void 0 : ButtonGroupProps.fullWidth) || buttonProps.fullWidth,
      children: [/*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
        ref: ref,
        onClick: handleClick,
        disabled: isLoading,
        isLoading: isLoading
      }, buttonProps), {}, {
        children: label
      })), /*#__PURE__*/_jsx(CaretButton, {
        onClick: handleToggle,
        disabled: isLoading,
        color: buttonProps.color,
        variant: buttonProps.variant,
        "aria-haspopup": "menu",
        "aria-controls": open ? uid : undefined,
        "aria-expanded": open ? 'true' : undefined,
        children: /*#__PURE__*/_jsx(CaretDownIcon, {})
      })]
    })), /*#__PURE__*/_jsx(Popover, {
      open: open,
      onClose: handleClose,
      anchorEl: anchorRef.current,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      },
      children: /*#__PURE__*/_jsx("div", {
        style: {
          minWidth: (_anchorRef$current2 = anchorRef.current) === null || _anchorRef$current2 === void 0 ? void 0 : _anchorRef$current2.clientWidth
        },
        children: /*#__PURE__*/_jsx(MenuList, _objectSpread(_objectSpread({}, MenuListProps), {}, {
          id: uid,
          onClick: () => {
            setOpen(false);
          },
          children: children
        }))
      })
    })]
  });
});
if (process.env.NODE_ENV !== "production") DropdownButton.displayName = "DropdownButton";
export default DropdownButton;